import { createStore, applyMiddleware, compose, combineReducers } from 'redux'
import rootReducer from '../reducers/'
import {
  watchSISStatusData,
  watchCoursesData,
  watchProgrammesData,
  watchRolesData,
  watchTermsData,
  watchUsersData,
  watchPostEnrollmentsData,
  watchLoadSectionDataByID,
  watchAccessToken,
  watchProgrammesDataByID,
  uploadRequestWatcherSaga,
  watchUploadS3ZoomEvent,
  watchCourseStudentsData
} from '../services/saga'
import createSagaMiddleware from 'redux-saga'

import { createBrowserHistory } from 'history'
import { routerMiddleware } from 'connected-react-router'
import axios from 'axios'

export const history = createBrowserHistory()

import * as actions from '../actions/'

export default function configureStore(preloadedState) {
  const sagaMiddleware = createSagaMiddleware()

  const store = createStore(
    rootReducer(history),
    compose(applyMiddleware(sagaMiddleware, routerMiddleware(history)))
  )

  sagaMiddleware.run(watchCoursesData)
  sagaMiddleware.run(watchProgrammesData)
  sagaMiddleware.run(watchRolesData)
  sagaMiddleware.run(watchTermsData)
  sagaMiddleware.run(watchUsersData)
  sagaMiddleware.run(watchPostEnrollmentsData)
  sagaMiddleware.run(watchSISStatusData)
  sagaMiddleware.run(watchProgrammesDataByID)
  sagaMiddleware.run(uploadRequestWatcherSaga)
  sagaMiddleware.run(watchLoadSectionDataByID)
  sagaMiddleware.run(watchCourseStudentsData)

  axios.interceptors.response.use(
    (response) => {
      return response
    },
    (error) => {
      console.log('AXIO ERROR')

      if (error.response.status === 401) {
        console.log('AUTH ERROR, Login again')

        store.dispatch(actions.updateLoginExpireStatus(true))
      }

      return Promise.reject(error)
    }
  )

  return store
}
